import React from 'react';
import { Shield, Lock, CheckCircle } from 'lucide-react';

const TrustBar: React.FC = () => {
  const items = [
    { icon: <Shield size={18} />, text: 'Tus datos son tuyos. Siempre.' },
    { icon: <Lock size={18} />, text: 'Solo tu familia puede acceder' },
    { icon: <CheckCircle size={18} />, text: 'Gratis para empezar. Sin tarjeta.' },
  ];

  return (
    <section className="py-6 md:py-8 bg-stone-50 border-y border-stone-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 lg:gap-12">
          {items.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-2 text-stone-600 text-sm font-medium"
            >
              <span className="text-rose-500 shrink-0">{item.icon}</span>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
